

















  import { computed, defineComponent, PropType, ref } from 'vue'
  import { AxiosResponse } from 'axios'
  import { CMS, Pagination } from '@one/types'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import ArticleTag = CMS.Articles.Tags.ArticleTag
  import ArticleLink = CMS.Responses.ArticleLink

  export default defineComponent({
    components: {
      OneCmsArticle: () => import('~/components/organisms/grid/content/OneCmsArticle.vue'),
    },
    props: {
      articlesLimit: {
        type: Number,
        required: true,
      },
      tags: {
        type: Array as PropType<{ id: string; name: string }[]>,
        required: true,
      },
    },
    setup(props) {
      const vm = useCurrentInstance()
      const articles = ref<ArticleLink[]>([])
      const limitedArticles = computed(() => articles.value.slice(0, props.articlesLimit))
      const isArticleFillSettingsEnabled = computed(() =>
        vm.$store.getters['cms/isArticleFillSettingsEnabled'],
      )
      const shouldShowBlogModule = computed(
        () => isArticleFillSettingsEnabled.value && articles.value.length,
      )

      const fetchArticles = () => {
        const pageSize = props.articlesLimit
        const pageNumber = 1
        const tags = props.tags.map((tag: ArticleTag) => tag.id)
        vm.$api.cms.app
          .getArticlesWithFill(pageNumber, pageSize, tags)
          .then(({ data }: AxiosResponse<Pagination.Pager<ArticleLink>>) => {
            articles.value = data.items
          })
          .catch((error) => {
            console.error('Error fetching articles:', error)
            articles.value = []
          })
      }

      fetchArticles()

      return {
        shouldShowBlogModule,
        limitedArticles,
      }
    },
  })
